import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'mobx-react'

import { isPresent } from '../../../lib/utils/collection'
import CardPreviewSkeleton from '../CardPreviewSkeleton/CardPreviewSkeleton'
import CardContent from '../CardContent/CardContent'
import { rootStoreInstance } from '../../Srp/SearchBar/stores'
import CardCarousel from '../CardCarousel'

const CardMapPreview = ({
  activeItem,
  handleOnSaveClick,
  removeMarkAsActive,
  isLoading
}) => {
  const wrapperRef = useRef(null)

  const handleDoubleClick = e => {
    e.stopPropagation()
  }

  useEffect(() => {
    const handleClickOutside = event => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        removeMarkAsActive()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('touchstart', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('touchstart', handleClickOutside)
    }
  }, [removeMarkAsActive])

  if (isLoading) {
    return (
      <div className='CardMapPreview'>
        <CardPreviewSkeleton />
      </div>
    )
  }

  return (
    isPresent(activeItem)
      ? (
        <Provider store={rootStoreInstance}>
          <a href={activeItem.links.self} className='CardMapPreview' onDoubleClick={handleDoubleClick} ref={wrapperRef}>
            <CardCarousel
              containsVideoTour={activeItem.isVideoTour}
              containsZillow3dTour={activeItem.isZillow3dTour}
              closestOpenHouseDate={activeItem.openHouseDateDisplay}
              closestOpenHouseTime={activeItem.openHouseTimeDisplay}
              isRecent={activeItem.isRecent}
              isActive={activeItem.active}
              status={activeItem.statusDisplay}
              initialPhoto={activeItem.initialCardPhotos}
              listingId={activeItem.id}
              highlights={activeItem.highlights}
              listingClass={activeItem.listingClass}
            />
            <CardContent
              address={activeItem.address}
              undisclosedAddressText='(Undisclosed Address)'
              saved={activeItem.saved}
              id={activeItem.id}
              townName={activeItem.townName}
              price={activeItem.priceDisplay}
              currentPricePeriodLabel={activeItem.periodDisplay}
              land={activeItem.isLand}
              beds={activeItem.bedsDisplay}
              bathsDisplay={activeItem.bathsDisplay}
              acreage={activeItem.acreageDisplay}
              sqft={activeItem.sqftDisplay}
              byOwner={activeItem.isByOwner}
              listingBy={activeItem.brokerageNameDisplay}
              isActive={activeItem.active}
              listingClass={activeItem.listingClass}
              links={activeItem.links}
              onSave={handleOnSaveClick}
            />
          </a>
        </Provider>
      )
      : null
  )
}

CardMapPreview.propTypes = {
  activeItem: PropTypes.object,
  handleOnSaveClick: PropTypes.func.isRequired,
  removeMarkAsActive: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
}

export default CardMapPreview
